import { forwardRef, useImperativeHandle, useId } from 'react';
import type { PapiUser } from '@wix/da-papi-types';
import {
  ThemeOverride,
  ThemeSurface,
} from '@wix/da-react-context/pkg/ThemeContext';
import AutoCompleteMenu from '@wix/da-ds/pkg/formControls/layouts/AutoCompleteLayout/AutoCompleteMenu';
import { useAutoCompleteKeyboardSupport } from '@wix/da-ds/pkg/formControls/layouts/AutoCompleteLayout/hooks';
import s from './MentionList.scss';

export default forwardRef<any, any>((props, ref) => {
  const menuId = useId();

  const selectItem = (item: PapiUser | { label: string; value: string }) => {
    if ((item as PapiUser).username) {
      props.command({ user: item as PapiUser });
    } else {
      props.command({
        user: props.items[(item as { label: string; value: string }).value],
      });
    }
  };

  const [selectedIndex, onKeyDown] = useAutoCompleteKeyboardSupport(
    props.items,
    selectItem
  );

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => onKeyDown(event),
  }));

  if (!props.items || props.items.length === 0) {
    return null;
  }

  return (
    // TODO: AutoCompleteMenu is not meant to be used on its own, so a11y doesn't quite work here.
    // We need to figure out if we can alter the relevant editor node whilst the autocomplete menu is open.
    // Will have to apply the appropriate aria to said node attributes (see AutoCompleteLayout for an example of those).
    <ThemeOverride themeSurface={ThemeSurface.TERTIARY}>
      <AutoCompleteMenu
        menuId={menuId}
        items={
          props.items
            ? props.items.map((item, index) => ({
                label: (
                  <div className={s['user']}>
                    <img
                      src={
                        item.icon ??
                        'https://a.deviantart.net/avatars/default.gif'
                      }
                      height="25"
                      alt={item.username}
                    />{' '}
                    {item.username}
                  </div>
                ),
                value: index,
              }))
            : []
        }
        onSelectItem={selectItem}
        selectedIndex={selectedIndex}
        className={s['root']}
      />
    </ThemeOverride>
  );
});
